import * as Starknet from 'starknet';

import { type StarknetProvider } from '#/features/starknet-wallet/provider';

import { AsyncResult } from './types';

const WAIT_FOR_TRANSACTION_OPTIONS_DEFAULT_OVERRIDES: Starknet.waitForTransactionOptions =
  {
    errorStates: [
      Starknet.TransactionExecutionStatus.REJECTED,
      Starknet.TransactionExecutionStatus.REVERTED, // Not included in default options
    ],
  };

export async function waitForTransaction(
  provider: StarknetProvider,
  txnHash: Starknet.num.BigNumberish,
  options: Starknet.waitForTransactionOptions = {},
): AsyncResult<Starknet.GetTransactionReceiptResponse> {
  const finalOptions = {
    ...options,
    errorStates:
      options.errorStates ??
      WAIT_FOR_TRANSACTION_OPTIONS_DEFAULT_OVERRIDES.errorStates,
  };

  try {
    const response = await provider.waitForTransaction(txnHash, finalOptions);
    return { ok: true, data: response };
  } catch (cause) {
    const txReceipt = await provider.getTransactionReceipt(txnHash);
    const message = `Starknet transaction ${txReceipt.status}`;
    const error = new Error(message, { cause });
    return { ok: false, error };
  }
}
